module.exports = __webpack_public_path__ + "img/SMS-min.330c79ee.png";